import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SharedModule } from 'src/app/shared/shared.module'
import { LayoutsModule } from 'src/app/layouts/layouts.module'
import { AppPreloader } from 'src/app/app-routing-loader'
import { LayoutMainComponent } from './layouts/Main/main.component'
import { NotFoundComponent } from './core/pages/404.component'
import { AuthGuard } from './core/guards/auth.guard'

import { MsalGuard } from '@azure/msal-angular';

const COMPONENTS = []

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth'
  },
  {
    path: 'auth',
    loadChildren: 'src/app/modules/auth/auth.module#AUTHModule'
  },
  {
    path: '',
    component: LayoutMainComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: 'masters',
        loadChildren: 'src/app/modules/masters/masters.module#MASTERSModule',
      },
      // {
      //   path: 'area-ti',
      //   loadChildren: 'src/app/modules/area-ti/area-ti.module#AREATIModule',
      // },
      {
        path: 'performance',
        loadChildren: 'src/app/modules/performance/performance.module#PERFORMANCEModule',
      },
      {
        path: 'simulation',
        loadChildren: 'src/app/modules/simulation/simulation.module#SIMULATIONModule',
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'auth'
  }
]

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {
      useHash: false,
      preloadingStrategy: AppPreloader,
    }),
    LayoutsModule,
  ],
  providers: [AppPreloader],
  declarations: [...COMPONENTS],
  exports: [RouterModule],
})
export class AppRoutingModule {}
